module.exports = [{"title":"новая","id":"is_new"},{"title":"б/у","id":"is_used"},{"title":"оригинал","id":"is_original"},{"title":"аналог","id":"is_analogue"},{"title":"под заказ","id":"is_under_the_order"},{"title":"в наличии","id":"in_stock"},{"title":"доставка по Украине","id":"delivery_in_ukraine"}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/partsStatuses.json
// module id = 464
// module chunks = 49